import {applyMiddleware, createStore} from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import promise from 'redux-promise-middleware'
import { composeWithDevTools } from 'redux-devtools-extension';
import { reduxAPIHandler } from './redux-api-handler'
import config from './redux-api-handler/sampleConfig'

import rootReducer from './rootReducer'

let logger = []


if (process.env.NODE_ENV === 'development') {
  logger.push(createLogger())
}

const middleware = applyMiddleware(reduxAPIHandler(config), promise(), thunk)


const store = createStore(
  rootReducer,
  composeWithDevTools(
    middleware,
)
)

export default store



// WEBPACK FOOTER //
// ./src/redux/store.js